import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import SmartPhoneLoginButton from '@/materials/atoms/SmartPhoneLoginButton.vue';
import SmartPhoneOrder from '@/materials/atoms/SmartPhoneOrder.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    emits: ["click"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const orderType = (e) => {
            emits('click', e);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmartPhoneOrder, { onClick: orderType })
                ], 512), [
                    [_vShow, props.isAuth]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                    _createVNode(SmartPhoneLoginButton)
                ], 512), [
                    [_vShow, !props.isAuth]
                ])
            ], 64));
        };
    }
});
